// Learner App does not support translation (see /learnerApp/src/App.tsx)
/* eslint-disable i18next/no-literal-string */
import { useEffect, useState } from "react";

const LOADING_BUTTON_TEXT = ["Mixing...", "Spinning...", "Combining..."];
const LOADING_BUTTON_TEXT_CYCLE_INTERVAL_MS = 1000;

export default function useLoadingButtonText(shouldAnimate: boolean) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!shouldAnimate) {
      setIndex(0);
      return;
    }

    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % LOADING_BUTTON_TEXT.length);
    }, LOADING_BUTTON_TEXT_CYCLE_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [shouldAnimate]);

  return LOADING_BUTTON_TEXT[index];
}
